import React from "react";
import { InternalStandardProps, SxProps, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Input, { InputProps } from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { AppButton } from "./AppButton";
import "./style.css";

const Root = styled("div")({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});

const StyledInput = styled(Input)(({ theme }) => ({
    minHeight: "50px",
    color: `${theme.palette.common.black}`,
    "&::before": {
        borderBottomColor: `${theme.palette.grey[600]} !important`,
    },
    "&::after": {
        borderBottomColor: `${theme.colors?.textField?.focus} !important`,
    },
    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus":
        {
            transition:
                "background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s",
            transitionDelay: "background-color 5000s, color 5000s",
        },
}));

const SearchIconWrapper = styled(InputAdornment)(({ theme }) => ({
    color: `${theme.palette.grey[600]}`,
}));

const SearchWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(1, 0),
}));

const CancelBtn = styled(AppButton)(({ theme }) => ({
    height: "35px",
    marginLeft: theme.spacing(2),
}));

export interface AppSearchBarProps extends InternalStandardProps<InputProps> {
    onCancel?: () => void;
    elementId?: string;
    sx?: SxProps<Theme>;
}

export const AppSearchBar = (props: AppSearchBarProps) => {
    const { className, value, elementId, onCancel, sx, ...rest } = props;
    const searchId = elementId ? elementId : "standard-adornment-password";

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
            const input = document.getElementById(searchId);
            input?.blur();
        }
    };

    const customInputProps: any = {
        enterKeyHint: "Search",
    };

    return (
        <Root className={className} sx={sx}>
            <FormControl sx={{ m: 1, width: "100%" }} variant="standard">
                <StyledInput
                    {...rest}
                    id={searchId}
                    type="search"
                    value={value}
                    onKeyPress={handleKeyDown}
                    inputProps={customInputProps}
                    startAdornment={
                        <SearchIconWrapper position="start">
                            <SearchIcon />
                        </SearchIconWrapper>
                    }
                    endAdornment={
                        <SearchWrapper>
                            {(value as string)?.length > 0 && (
                                <CancelBtn
                                    onClick={onCancel}
                                    rounded
                                    buttonVariant="grey-outlined"
                                >
                                    Cancel
                                </CancelBtn>
                            )}
                        </SearchWrapper>
                    }
                />
            </FormControl>
        </Root>
    );
};
